/* eslint-disable no-unused-vars */
import { Typography } from "@mui/material";
import PCheck from "../../components/pos/PCheck";
import PSettingsCard from "../../components/pos/PSettingsCard.jsx";
import PText from "../../components/pos/PText";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import PSelect from "../../components/pos/PSelect";

export default function SuperAdminStore(props) {
  const { t } = useTranslation();
  const translate = t;
  const [liveValidation, setLiveValidation] = useState(false);

  const [terminalWiseInvoicing, setTerminalWiseInvoicing] = useState(false);
  const [offlineMode, setOfflineMode] = useState(false);
  const [enableOfflineMode, setEnableOfflineMode] = useState(true);
  const [invoicePrefix, setInvoicePrefix] = useState("");
  const [saleReturnPrefix, setSaleReturnPrefix] = useState("RET-");
  const [servicePrefix, setServicePrefix] = useState("SR-");
  const [saleOrderPrefix, setSaleOrderPrefix] = useState("SO-");
  const [enableShift, setEnableShift] = useState(false);
  const [enableAccounting, setEnableAccounting] = useState(false);
  const [postLedgerDuringSale, setPostledgerDuringSale] = useState(false);
  const [costingMethodeOptions, setCostingMethodeOptions] = useState([
    { name: "LIFO", code: "LIFO" },
    { name: "FIFO", code: "FIFO" },
    { name: "AVERAGE", code: "AVERAGE" },
  ]);
  const [costingMethode, setCostingMethode] = useState(null);
  const [
    postAccountingLedgersDuringDayClose,
    setPostAccountingLedgersDuringDayClose,
  ] = useState(false);

  const [dineIn, setDineIn] = useState(false);
  const [takeAway, setTakeAway] = useState(false);
  const [delivery, setDelivery] = useState(false);
  const [online, setOnline] = useState(false);
  const [allowEditingSale, setAllowEditingSale] = useState(false);
  const [allowEditingPo, setAllowEditingPo] = useState(false);
  const [renderProductFromCache, setRenderProductFromCache] = useState(false);
  const [switchUserWithCard, setSwitchUserWithCard] = useState(false);
  const [barcodeScanAvgTimeByChar, setBarcodeScanAvgTimeByChar] = useState(30);
  const [syncronizePricingWithBranch, setsyncronizePricingWithBranch] =
    useState(false);
  const [experimentalFeatures, setExpermentalFeatures] = useState(false);
  const [resetMinusStockDuringInventory, setResetMinusStockDuringInventory] =
    useState(false);
  const [saleListEngineOption, setSaleListEngineOption] = useState([
    { name: "Data Table", code: "mui-datatable" },
    { name: "AG Grid", code: "ag-grid" },
  ]);
  const [saleListEngine, setSaleListEngine] = useState({
    name: "AG Grid",
    code: "ag-grid",
  });

  const [saleOrderName, setSaleOrderName] = useState(
    props.context.storeAdmin.saleOrderName
      ? props.context.storeAdmin.saleOrderName
      : "Sale Order"
  );

  const [restoreUnfinishedSale, setRestoreUnfinishedSale] = useState(false);

  useEffect(() => {
    setEnableOfflineMode(!terminalWiseInvoicing);
  }, [terminalWiseInvoicing]);

  const content = (
    <table width="100%">
      <tbody>
        {(props.context.appType === "POS" ||
          props.context.appType === "M_POS") && (
          <tr>
            <td width={200}>
              <PCheck
                onChange={(value) => setTerminalWiseInvoicing(value)}
                checked={terminalWiseInvoicing}
                label={translate("Terminal wise invoicing")}
              ></PCheck>
            </td>
          </tr>
        )}
        {(props.context.appType === "POS" ||
          props.context.appType === "M_POS") && (
          <tr>
            <td width={200}>
              <PCheck
                onChange={(value) => setOfflineMode(value)}
                checked={offlineMode}
                label={translate("Enable offline mode")}
                disabled={enableOfflineMode}
              ></PCheck>
            </td>
          </tr>
        )}
        {props.context.appType === "R_POS" && (
          <tr>
            <td width={200}>
              <PCheck
                onChange={(value) => setDineIn(value)}
                checked={dineIn}
                label={translate("Dine-in")}
              ></PCheck>
            </td>
          </tr>
        )}
        {props.context.appType === "R_POS" && (
          <tr>
            <td width={200}>
              <PCheck
                onChange={(value) => setTakeAway(value)}
                checked={takeAway}
                label={translate("Takeaway")}
              ></PCheck>
            </td>
          </tr>
        )}{" "}
        {props.context.appType === "R_POS" && (
          <tr>
            <td width={200}>
              <PCheck
                onChange={(value) => setDelivery(value)}
                checked={delivery}
                label={translate("Delivery")}
              ></PCheck>
            </td>
          </tr>
        )}
        {props.context.appType === "R_POS" && (
          <tr>
            <td width={200}>
              <PCheck
                onChange={(value) => setOnline(value)}
                checked={online}
                label={translate("Online")}
              ></PCheck>
            </td>
          </tr>
        )}
        <tr>
          <td>
            <Typography variant="body1">
              {translate("Invoice prefix")}
            </Typography>
          </td>
          <td width={200}>
            <PText
              type={"text"}
              value={invoicePrefix}
              onChange={(e) => setInvoicePrefix(e.target.value)}
            ></PText>
          </td>
        </tr>
        {(props.context.appType === "POS" ||
          props.context.appType === "M_POS") && (
          <tr>
            <td>
              <Typography variant="body1">
                {translate("Sale return prefix")}
              </Typography>
            </td>
            <td width={200}>
              <PText
                type={"text"}
                value={saleReturnPrefix}
                onChange={(e) => setSaleReturnPrefix(e.target.value)}
              ></PText>
            </td>
          </tr>
        )}
        {(props.context.appType === "POS" ||
          props.context.appType === "M_POS") && (
          <tr>
            <td>
              <Typography variant="body1">
                {translate("Service prefix")}
              </Typography>
            </td>
            <td width={200}>
              <PText
                type={"text"}
                value={servicePrefix}
                onChange={(e) => setServicePrefix(e.target.value)}
              ></PText>
            </td>
          </tr>
        )}
        {(props.context.appType === "POS" ||
          props.context.appType === "M_POS") && (
          <tr>
            <td>
              <Typography variant="body1">
                {translate(
                  (props.context.storeAdmin.saleOrderName
                    ? props.context.storeAdmin.saleOrderName
                    : "Sale order") + " prefix "
                )}
              </Typography>
            </td>
            <td width={200}>
              <PText
                type={"text"}
                value={saleOrderPrefix}
                onChange={(e) => setSaleOrderPrefix(e.target.value)}
              ></PText>
            </td>
          </tr>
        )}
        <tr>
          <td>
            <Typography variant="body1">
              {translate("Product costing method")}
            </Typography>
          </td>
          <td width={200}>
            <PSelect
              options={costingMethodeOptions}
              value={costingMethode}
              onChange={(event, newValue) => {
                setCostingMethode(newValue);
              }}
            ></PSelect>
          </td>
        </tr>
        <tr>
          <td>
            <Typography variant="body1">
              {translate("Sale list framework")}
            </Typography>
          </td>
          <td width={200}>
            <PSelect
              options={saleListEngineOption}
              value={saleListEngine}
              onChange={(event, newValue) => {
                setSaleListEngine(newValue);
              }}
            ></PSelect>
          </td>
        </tr>
        <tr>
          <td width={200}>
            <PCheck
              onChange={(value) => setEnableShift(value)}
              checked={enableShift}
              label={translate("Enable shift")}
            ></PCheck>
          </td>
        </tr>
        {/*<tr>
          <td width={200}>
            <PCheck
              onChange={(value) => setEnableAccounting(value)}
              checked={enableAccounting}
              label={translate("Enable Accounting")}
            ></PCheck>
          </td>
            </tr>*/}
        <tr>
          <td colSpan={2}>
            <PCheck
              onChange={(value) =>
                setPostAccountingLedgersDuringDayClose(value)
              }
              checked={postAccountingLedgersDuringDayClose}
              label={translate("Post accouting ledgers during day close")}
            ></PCheck>
          </td>
        </tr>
        <tr>
          <td colSpan={2}>
            <PCheck
              onChange={(value) => setAllowEditingPo(value)}
              checked={allowEditingPo}
              label={translate("Allow editing purchase")}
            ></PCheck>
          </td>
        </tr>
        <tr>
          <td colSpan={2}>
            <PCheck
              onChange={(value) => setAllowEditingSale(value)}
              checked={allowEditingSale}
              label={translate("Allow editing sale")}
            ></PCheck>
          </td>
        </tr>
        <tr>
          <td colSpan={2}>
            <PCheck
              onChange={(value) => setRenderProductFromCache(value)}
              checked={renderProductFromCache}
              label={translate("Use cached data in product list screen")}
            ></PCheck>
          </td>
        </tr>
        <tr>
          <td colSpan={2}>
            <PCheck
              onChange={(value) => setSwitchUserWithCard(value)}
              checked={switchUserWithCard}
              label={translate("Switch user with card")}
            ></PCheck>
          </td>
        </tr>
        <tr>
          <td>
            <Typography variant="body1">
              {translate("Barcode scan keyboard interval in milli sec")}
            </Typography>
          </td>
          <td width={200}>
            <PText
              type={"number"}
              value={barcodeScanAvgTimeByChar}
              onChange={(e) => setBarcodeScanAvgTimeByChar(e.target.value)}
            ></PText>
          </td>
        </tr>
        <tr>
          <td colSpan={2}></td>
        </tr>
        <tr>
          <td>
            <Typography variant="body1">
              {translate("Sale order name")}
            </Typography>
          </td>
          <td>
            <PText
              type={"text"}
              value={saleOrderName}
              onChange={(e) => setSaleOrderName(e.target.value)}
            ></PText>
          </td>
        </tr>
        <tr>
          <td colSpan={2}>
            <PCheck
              onChange={(value) => setsyncronizePricingWithBranch(value)}
              checked={syncronizePricingWithBranch}
              label={translate(
                "Syncronize product pricing with branch (Warehouse)"
              )}
            ></PCheck>
          </td>
        </tr>
        <tr>
          <td colSpan={2}>
            <PCheck
              onChange={(value) => setResetMinusStockDuringInventory(value)}
              checked={resetMinusStockDuringInventory}
              label={translate("Reset minus stock during purchase")}
            ></PCheck>
          </td>
        </tr>
        <tr>
          <td colSpan={2}>
            <PCheck
              onChange={(value) => setExpermentalFeatures(value)}
              checked={experimentalFeatures}
              label={translate("Enable experimental features")}
            ></PCheck>
          </td>
        </tr>
        <tr>
          <td colSpan={2}>
            <PCheck
              onChange={(value) => setRestoreUnfinishedSale(value)}
              checked={restoreUnfinishedSale}
              label={translate("Restore unfinished sale")}
            ></PCheck>
          </td>
        </tr>
      </tbody>
    </table>
  );

  function validate() {
    setLiveValidation(true);
    return true;
  }

  function validateItemCodeLen() {}

  function createPayload(payload) {
    payload["offlineMode"] = offlineMode;
    payload["terminalWiseInvoicing"] = terminalWiseInvoicing;
    payload["invoicePrefix"] = invoicePrefix;
    payload["saleReturnPrefix"] = saleReturnPrefix;
    payload["servicePrefix"] = servicePrefix;
    payload["saleOrderPrefix"] = saleOrderPrefix;
    payload["enableShift"] = enableShift;
    payload["costingMethodeCode"] = costingMethode ? costingMethode.code : "";
    payload["costingMethodeName"] = costingMethode ? costingMethode.name : "";
    payload["enableAccounting"] = enableAccounting;
    payload["postLedgerDuringSale"] = postLedgerDuringSale;
    payload["postAccountingLedgersDuringDayClose"] =
      postAccountingLedgersDuringDayClose;
    payload["rDineIn"] = dineIn;
    payload["rTakeAway"] = takeAway;
    payload["rDelivery"] = delivery;
    payload["rOnline"] = online;
    payload["allowEditingSale"] = allowEditingSale;
    payload["allowEditingPo"] = allowEditingPo;

    payload["switchUserWithCard"] = switchUserWithCard;
    payload["barcodeScanAvgTimeByChar"] = barcodeScanAvgTimeByChar;

    payload["renderProductFromCache"] = renderProductFromCache;

    if (props.context.appType === "R_POS") {
      payload["offlineMode"] = false;
      payload["terminalWiseInvoicing"] = false;
    }
    payload["saleOrderName"] = saleOrderName;
    payload["saleListEngine"] = JSON.stringify(saleListEngine);
    payload["syncronizePricingWithBranch"] = syncronizePricingWithBranch;
    payload["resetMinusStockDuringInventory"] = resetMinusStockDuringInventory;
    payload["experimentalFeatures"] = experimentalFeatures;
    payload["restoreUnfinishedSale"] = restoreUnfinishedSale;
  }

  function populateObject(bean) {
    console.log(bean);
    setOfflineMode(bean.offlineMode);
    setTerminalWiseInvoicing(bean.terminalWiseInvoicing);
    setInvoicePrefix(bean.invoicePrefix);
    setSaleReturnPrefix(bean.saleReturnPrefix);
    setServicePrefix(bean.servicePrefix);
    setSaleOrderPrefix(bean.saleOrderPrefix);
    setDineIn(bean.rDineIn);
    setTakeAway(bean.rTakeAway);
    setDelivery(bean.rDelivery);
    setOnline(bean.rOnline);
    setAllowEditingSale(bean.allowEditingSale);
    setAllowEditingPo(bean.allowEditingPo);
    setsyncronizePricingWithBranch(bean.syncronizePricingWithBranch);
    setExpermentalFeatures(bean.experimentalFeatures);
    setResetMinusStockDuringInventory(
      bean.resetMinusStockDuringInventory
        ? bean.resetMinusStockDuringInventory
        : false
    );

    if (bean.costingMethodeName && bean.costingMethodeCode) {
      setCostingMethode({
        name: bean.costingMethodeName,
        code: bean.costingMethodeCode,
      });
    }
    setEnableAccounting(bean.enableAccounting);
    setPostledgerDuringSale(bean.postLedgerDuringSale);
    setPostAccountingLedgersDuringDayClose(
      bean.postAccountingLedgersDuringDayClose
    );
    setRenderProductFromCache(bean.renderProductFromCache);
    setSaleOrderName(bean.setSaleOrderName ? bean.saleOrderName : "Sale Order");
    setSwitchUserWithCard(bean.switchUserWithCard);
    setBarcodeScanAvgTimeByChar(bean.barcodeScanAvgTimeByChar);

    setRestoreUnfinishedSale(bean.restoreUnfinishedSale);

    setSaleListEngine(
      bean.saleListEngine
        ? JSON.parse(bean.saleListEngine)
        : {
            name: "AG Grid",
            code: "ag-grid",
          }
    );
  }

  return (
    <PSettingsCard
      avatar="S"
      title={translate("Store Setting")}
      cardContent={content}
      onValidate={validate}
      createPayload={createPayload}
      populateObject={populateObject}
      messagHandler={props.messagHandler}
      settingKey="store_admin"
    ></PSettingsCard>
  );
}
